import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const buttonWrapper = css({
  margin: '9px 0 23px',

  button: {
    marginTop: 23,
    [MediaQueries.mdAndUp]: {
      marginTop: 0,
    },
  },

  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
    marginRight: 24,
  },
});

export const panel = css({
  '@supports(-webkit-touch-callout: none)': {
    paddingBottom: 155,
  },
});
